<ddv-query-params
    [clientMode]="clientPickerMode"
    [funds]="funds"
    [(selectedFunds)]="selectedFunds"
    [clients]="clients"
    [(selectedClients)]="selectedClients"
    [dateMode]="datePickerMode"
    [fuzzyDates]="fuzzyDates"
    [fromDate]="fromDate"
    [toDate]="toDate"
    [periodStatuses]="periodStatuses"
    (selectedFundsChange)="applyFunds.emit($event)"
    (selectedClientsChange)="applyClients.emit($event)"
    (dateRangeChange)="onDateRangeChanged($event)"
    (dateChange)="onDateChanged($event)"
>
</ddv-query-params>

@if (isActiveDateSupported) {
    <ddv-active-date-picker
        [mode]="activeDateMode"
        [date]="queryParams.activeDate ?? undefined"
        [fuzzyDates]="fuzzyDates"
        [allowedRange]="{ fromDate, toDate }"
        (modeChange)="updateActiveDateMode($event)"
        (dateChange)="applyActiveDate($event)"
    >
    </ddv-active-date-picker>
}

@if (showAdditionalFilters) {
    <ddv-additional-filters
        [clientCode]="clientCode"
        [id]="id"
        [additionalFilters]="queryParams.additionalFilters ?? []"
        [namedQueries]="namedQueries"
        (additionalFiltersChange)="onAdditionalFiltersChanged($event)"
    >
    </ddv-additional-filters>
}

<ng-content>
    <!-- blocks that are specific to certain use cases are inserted here -->
</ng-content>

@if (showSlowDataApproval) {
    <ddv-slow-data-approval
        [clientCode]="clientCode"
        [selectedDate]="dateToCheckSlowness"
        [fuzzyDates]="fuzzyDates"
        (approved)="onSlowDataApprovalResponse($event)"
    >
    </ddv-slow-data-approval>
}
